(function($) {

	// Settings
	var defaults = {
		columns: 2,
		direction: 'vertical',
		// container
		containerTag: 'div',
		containerClass: 'list-container',
		// column
		columnTag: 'ul',
		columnClass: 'list-column',
		columnFirstClass: 'list-column_first',
		columnLastClass: 'list-column_last',
		columnAllowEmpty: false,
		filter: '',
		rul: '',
		cloneEvent: true
	};

	// Splitter function
	$.fn.splitter = function(options) {

		// Settings
		var settings = $.extend(false, defaults, options);

		// Install splitter for each items
		this.each(function(){

			// Variables and objects
			var $list = $(this),
				$items = $list.children(),
				$column = $('<'+settings.columnTag+'/>', {
					'class': settings.columnClass
				}),
				$container = $('<'+settings.containerTag+'/>', {
					'class': settings.containerClass
				}),
				$columns;

			if ($.isFunction(settings.filter)) $items = settings.filter($items);
			else if (settings.filter) $items = $items.filter(settings.filter);

			var itemsNumber = $items.length;
			// Find coolumns
			function findColumns(){
				$columns = $container.children();
			};

			// Vertical split
			function splitVertical(){
				var itemsInColumn = Math.ceil(itemsNumber/settings.columns),
					column = 0;
				for (var i=0; i<itemsNumber; i+=itemsInColumn) {
					var $columnItems = $items.slice(i, i+itemsInColumn).clone(settings.cloneEvent);
					$columns.eq(column++).append($columnItems);
				};
			};

			// Horizontal split
			function splitHorizontal(){
				if (settings.rul != '') {
					var range1 = 0, range2 = 0;
					$columns.each(function(index) {
						var rul = settings.rul[index];

						range2 = range2 + rul;
						if (!rul) range2 = $items.length;
						$(this).append($items.slice(range1, range2).clone(settings.cloneEvent));
						range1 = range2;
					});
				} else {
					$items.each(function(index){
						$columns.eq(index%settings.columns).append($(this).clone(settings.cloneEvent));
					});
				}
			};

			// Create columns
			for (var i=0; i<settings.columns; i++) $container.append($column.clone());
			findColumns();

			// Add items in columns
			if (settings.direction=='horizontal') splitHorizontal();
			else splitVertical();

			// Remove empty columns
			if (!settings.columnAllowEmpty) {
				$columns.filter(':empty').remove();
				findColumns();
			};

			// Add classes to first and last columns
			$columns.first().addClass(settings.columnFirstClass);
			$columns.last().addClass(settings.columnLastClass);

			// Render splitted list
			$items.last().after($container);
			$items.remove();

		});

		return this;
	};

})(jQuery);